import { Pipe, PipeTransform } from '@angular/core';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { DateService } from '../../services/date/date.service';

@Pipe({
    name: 'ngbDate'
})
export class NgbDatePipe implements PipeTransform {

    constructor (private date: DateService) {}

    transform(value: NgbDateStruct): string {

        let result = '';

        if (value) {
            result = this.date.formatDateStruct(value);
        }

        return result;
    }

}
